import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { CartService } from "../../../services/cart.service";
import { CartService as CartStoreService } from "../../../services/cart/cart.service";
@Component({
  selector: "nav-cart",
  templateUrl: "./nav-cart.component.html",
  styleUrls: ["./nav-cart.component.scss"],
})
export class NavCartComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();

  public hidden: boolean = true;

  constructor(
    private router: Router,
    public _batsCart: CartService,
    public _storeCart: CartStoreService
  ) {}

  get items() {
    return (
      (this._batsCart.items || []).reduce(
        (acc, { cantidad }) => (acc += cantidad),
        0
      ) + this._storeCart.cart.quantity
    );
  }

  ngOnInit(): void {
    this._batsCart.loadCart();
  }

  goShopping() {
    this.router.navigate(["/shopping"]);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
